<template>
  <b-row>
    <b-col
      md="4"
      class="my-1"
    >
      <b-form-group
        label="Clasificar"
        label-for="sortBySelect"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-select
            id="sortBySelect"
            v-model="sortBy"
            :options="sortOptions"
            class="w-75"
          >
            <template v-slot:first>
              <option value="">
                -- none --
              </option>
            </template>
          </b-form-select>
          <b-form-select
            v-model="sortDesc"
            size="sm"
            :disabled="!sortBy"
            class="w-25"
          >
            <option :value="false">
              ASC
            </option>
            <option :value="true">
              DESC
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      md="4"
      class="my-1"
    />
    <b-col
      md="4"
      class="my-1"
    >
      <b-form-group
        :label="`Coincidencias [ ${totalRows} ]`"
        label-align-sm="right"
        label-for="filterInput"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Buscar.."
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              Limpiar
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :sticky-header="true"
        :no-border-collapse="true"
        :items="datos"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(acepta_seguir)="row">
          <b-badge variant="light-primary">
            {{ (row.item.acepta_seguir === null) ? 'Sin Confirmar' : (row.item.acepta_seguir == 1) ? 'SI' : 'NO' }}
          </b-badge>
        </template>

        <template #cell(desc_status)="row">
          <b-badge variant="success">
            {{ row.item.desc_status }}
          </b-badge>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable, BBadge, BRow, BCol, BFormGroup, BFormSelect, BInputGroup, BFormInput, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
} from '@vue/composition-api'

export default {
  components: {
    BTable,
    // BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    // BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  props: {
    datos: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    // variables
    const totalRows = ref(1)
    const sortBy = ref(null)
    const sortDesc = ref(false)
    const filter = ref(null)
    const filterOn = ref([])

    const tableColumns = ref([
      { key: 'agenda', label: 'Agenda', sortable: true },
      { key: 'clv_periodo', label: 'Periodo', sortable: true },
      { key: 'acepta_seguir', label: 'Seguir?' },
      { key: 'nombre', label: 'Curso' },
      { key: 'grupo', label: 'Grupo', sortable: true },
      { key: 'desc_status', label: 'Status' },
      'cal_fin',
    ])

    // methods
    const sortOptions = computed(() =>
      // Create an options list from our fields
      // eslint-disable-next-line implicit-arrow-linebreak
      tableColumns.value.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key })))

    const onFiltered = filteredItems => {
    // Trigger pagination to update the number of buttons/pages due to filtering
      totalRows.value = filteredItems.length
    }

    onMounted(() => {
      // Set the initial number of items
      totalRows.value = props.datos.length
    })

    return {
      // values
      totalRows,
      sortBy,
      sortDesc,
      // sortDirection,
      filter,
      filterOn,
      // status,
      tableColumns,
      sortOptions,
      // tasks
      // avatarText,
      // info,
      // resetInfoModal,
      onFiltered,

    }
  },
}
</script>
